// The Sanskrit course's page layout: the shared Suvaani course layout (same header, footer, bottom bar and Kids
// decorations as the Prakrit course) with the Sanskrit sections, the Sanskrit search and the shared Preferences sheet
// (opened through the Sanskrit UI state, which also holds the course's own two rows). `variant='focus'` is the full
// screen lesson player.

import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/sanskrit/types'
import type { SiteNavItem } from '@/components/app/site-header'

import { BookA, BookOpen, Dumbbell, FlaskConical, GraduationCap, House, TrendingUp } from 'lucide-react'
import { useUi } from '@/sanskrit/components/providers/ui-state'
import { SiteHeader } from '@/components/app/site-header'
import { PreferencesButton } from '@/components/app/settings-controls'
import { Layout as CourseLayout } from '@/components/generals/layout'

const NAV: SiteNavItem[] = [
    { href: '/sanskrit', label: 'Home', icon: House },
    { href: '/sanskrit/learn', label: 'Learn', icon: GraduationCap },
    { href: '/sanskrit/practice', label: 'Practice', icon: Dumbbell },
    { href: '/sanskrit/grammar', label: 'Grammar', icon: FlaskConical },
    { href: '/sanskrit/vocabulary', label: 'Vocabulary', icon: BookA },
    { href: '/sanskrit/stories', label: 'Stories', icon: BookOpen },
    { href: '/sanskrit/progress', label: 'Progress', icon: TrendingUp }
]

const Header: FC = (): ReactNode => {
    const { setSearchOpen, setSettingsOpen } = useUi()

    return (
        <SiteHeader
            course='sanskrit'
            nav={NAV}
            onSearch={() => setSearchOpen(true)}
            settings={<PreferencesButton onClick={() => setSettingsOpen(true)} />}
        />
    )
}

export const Layout: FC<LayoutProps & { variant?: 'default' | 'focus' }> = ({ children, variant = 'default' }): ReactNode => {
    if (variant === 'focus') {
        return (
            <div className='paper flex min-h-screen flex-col'>
                <main id='main' className='flex-1'>
                    {children}
                </main>
            </div>
        )
    }

    return (
        <CourseLayout course='sanskrit' header={<Header />}>
            {children}
        </CourseLayout>
    )
}
